import { render, staticRenderFns } from "./Hojaanestecia.vue?vue&type=template&id=a53df7a0"
import script from "./Hojaanestecia.vue?vue&type=script&lang=js"
export * from "./Hojaanestecia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports